const HEX_SQRT3 = Math.sqrt(3);

export const getGridWorldDimensions = (cols, rows, type = 'square') => (
  type === 'hex'
    ? { width: 1.5 * cols + 0.5, height: HEX_SQRT3 * (rows + 0.5) }
    : { width: cols, height: rows }
);

export const getGridCellCenter = (x, y, cols, rows, type = 'square') => {
  const { width, height } = getGridWorldDimensions(cols, rows, type);
  if (type === 'hex') {
    const centerX = 1 + x * 1.5;
    const centerY = HEX_SQRT3 / 2 + y * HEX_SQRT3 + (x % 2 === 1 ? HEX_SQRT3 / 2 : 0);
    return { x: centerX - width / 2, y: height / 2 - centerY };
  }
  return { x: x + 0.5 - width / 2, y: height / 2 - (y + 0.5) };
};

const appendLine = (positions, x1, y1, x2, y2, width, height) => {
  positions.push(
    x1 - width / 2,
    height / 2 - y1,
    0,
    x2 - width / 2,
    height / 2 - y2,
    0
  );
};

export const buildGridLinePositions = (cols, rows, type = 'square') => {
  const { width, height } = getGridWorldDimensions(cols, rows, type);
  const positions = [];

  if (type !== 'hex') {
    for (let x = 0; x <= cols; x += 1) {
      appendLine(positions, x, 0, x, rows, width, height);
    }
    for (let y = 0; y <= rows; y += 1) {
      appendLine(positions, 0, y, cols, y, width, height);
    }
    return positions;
  }

  for (let col = 0; col < cols; col += 1) {
    const centerX = 1 + col * 1.5;
    const columnOffset = col % 2 === 1 ? HEX_SQRT3 / 2 : 0;
    for (let row = 0; row < rows; row += 1) {
      const centerY = HEX_SQRT3 / 2 + row * HEX_SQRT3 + columnOffset;
      for (let side = 0; side < 6; side += 1) {
        const angle = (Math.PI / 3) * side;
        const nextAngle = (Math.PI / 3) * ((side + 1) % 6);
        appendLine(
          positions,
          centerX + Math.cos(angle),
          centerY + Math.sin(angle),
          centerX + Math.cos(nextAngle),
          centerY + Math.sin(nextAngle),
          width,
          height
        );
      }
    }
  }
  return positions;
};

export const buildGridCellTrianglePositions = (cells, cols, rows, type = 'square') => {
  const { width, height } = getGridWorldDimensions(cols, rows, type);
  const positions = [];

  cells.forEach(({ x, y }) => {
    if (type !== 'hex') {
      const left = x;
      const right = x + 1;
      const top = y;
      const bottom = y + 1;
      appendTriangle(positions, left, top, right, top, right, bottom, width, height);
      appendTriangle(positions, left, top, right, bottom, left, bottom, width, height);
      return;
    }

    const centerX = 1 + x * 1.5;
    const centerY = HEX_SQRT3 / 2 + y * HEX_SQRT3 + (x % 2 === 1 ? HEX_SQRT3 / 2 : 0);
    for (let side = 0; side < 6; side += 1) {
      const angle = (Math.PI / 3) * side;
      const nextAngle = (Math.PI / 3) * ((side + 1) % 6);
      appendTriangle(
        positions,
        centerX,
        centerY,
        centerX + Math.cos(angle),
        centerY + Math.sin(angle),
        centerX + Math.cos(nextAngle),
        centerY + Math.sin(nextAngle),
        width,
        height
      );
    }
  });

  return positions;
};

const appendTriangle = (positions, x1, y1, x2, y2, x3, y3, width, height) => {
  positions.push(
    x1 - width / 2, height / 2 - y1, 0,
    x2 - width / 2, height / 2 - y2, 0,
    x3 - width / 2, height / 2 - y3, 0
  );
};